import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { CompaniesService } from "../companies/companies.service";
import { ApiService } from "../shared";
import { ProjectsService } from "../projects/projects.service";
import { ConfigService } from "../config.service";
import { UsersService } from "../users/users.service";
import { ProjectMember } from "../projectmember/projectmember.service";
import * as async from "async";
import { Router } from "@angular/router";

@Injectable()
export class AccountsService {
  static currentAccount: any;
  private serviceUrl = ConfigService.serviceUrl;

  constructor(
    private http: Http,
    private companiesService: CompaniesService,
    private apiService: ApiService,
    private projectsService: ProjectsService,
    private usersService: UsersService,
    private router: Router,
    private memberService: ProjectMember
  ) {}

  getAccounts(): Observable<any> {
    return this.http
      .get(`${this.serviceUrl}/accounts`)
      .map((res) => {
        return this.extractData(res, true);
      })
      .map((res) => {
        async.eachSeries(res, (account, callback) => {
          if (this.router.url === "/accounts") {
            this.usersService.getUsers(account.id).subscribe((users) => {
              account.users = users || null;
              callback();
            });
          } else {
            callback();
          }
        });
        return res;
      })
      .catch(this.handleError);
  }

  createAccount(account: any, users: any[]): Observable<any> {
    return new Observable((obs) => {
      let validUsers = this.usersService.validateUsers(users);
      if (validUsers !== true) {
        obs.error(validUsers);
        obs.complete();
      } else {
        this.http.post(`${this.serviceUrl}/accounts`, account).subscribe(
          (resp) => {
            this.usersService.createUsers(users, resp.json().id).subscribe(
              (u) => {
                this.extractData(resp, null);
                obs.next(resp);
                obs.complete();
              },
              (err) => {
                this.handleError(err);
                obs.error(err);
                obs.complete();
              }
            );
          },
          (error) => {
            this.handleError(error);
            obs.error(error);
            obs.complete();
          }
        );
      }
    });
  }

  editAccount(account: any, users: any[]): Observable<any> {
    return new Observable((obs) => {
      let validUsers = this.usersService.validateUsers(users);
      if (validUsers !== true) {
        obs.error(validUsers);
        obs.complete();
      } else {
        this.http
          .put(`${this.serviceUrl}/accounts/` + account.id, account)
          .subscribe(
            (resp) => {
              this.usersService.editUsers(users).subscribe(
                (u) => {
                  this.extractData(resp, null);
                  obs.next(resp);
                  obs.complete();
                },
                (err) => {
                  this.handleError(err);
                  obs.error(err);
                  obs.complete();
                }
              );
            },
            (error) => {
              this.handleError(error);
              obs.error(error);
              obs.complete();
            }
          );
      }
    });
  }

  // GET PROJECT NAMES - pass in the array containing project ids and get corresponding names.
  getProjNames(project_ids: any[]) {
    const projectObj = {}; // object containing both id and name of the project.
    const projectsArr = []; // Final array containing the projectObj as elements in the array.
    //Ex: [{'id':'123', 'name':'test project'}, {'id':'456', 'name':'another test'}]
    this.projectsService.getProjectList().subscribe((projectList) => {
      //Iterate through the project_ids array and projectList and compare to see if the project id's match
      for (let i = 0; i < project_ids.length; i++) {
        for (let j = 0; j < projectList.length; j++) {
          if (project_ids[i] === projectList[j].id) {
            //create dynamic projectObj's and assign new objects to them.
            projectObj[j] = { id: project_ids[i], name: projectList[j].name };
            // push all the objects into the array
            projectsArr.push(projectObj[j]);
          }
        }
      }
    });
    return projectsArr;
  }

  getProjectNames(accounts: any[]) {
    this.projectsService.getProjectList().subscribe((projectList) => {
      accounts.map((account) => {
        account.projectNames = [];
        if (account.project_ids && account.project_ids.length < 1) {
          account.projectNames = ["<any>"];
        } else if (account.project_ids) {
          account.project_ids.map((id) => {
            let projects = projectList.filter((it) => {
              return it.id === id;
            });
            if (projects.length > 0) {
              account.projectNames.push(projects[0].name);
            }
          });
        }
      });
    });
  }

  getEmployerName(accounts: any[]) {
    this.companiesService.getEmployers().subscribe((employerList) => {
      accounts.map((account) => {
        account.employerName = "";
        if (!account.company_id) {
          account.employerName = "<any>";
        } else {
          let employer = employerList.filter((it) => {
            return it.id === account.company_id;
          });
          if (employer.length > 0) {
            account.employerName = employer[0].name;
          }
        }
      });
    });
  }

  getEmployers() {
    return this.companiesService.getEmployers();
  }

  getProjects() {
    return this.projectsService.getProjectList();
  }

  getProjectMemberList(projectIds: string[]) {
    return this.memberService.getProjectMemberList(projectIds);
  }

  getItemsPerPageValues(): number[] {
    return ConfigService.itemsPerPageValues;
  }

  getItemsPerPage(): number {
    return ApiService.getItemsPerPage();
  }

  saveItemsPerPage(value: number) {
    ApiService.saveItemsPerPage(value);
  }

  private extractData(res: Response, getNames: boolean) {
    let body = res.json();
    if (getNames) {
      this.getProjectNames(body);
      this.getEmployerName(body);
    }
    return body;
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounts/accounts.service.ts